/**
 * axios 的请求信息处理类
 */
import store from '@/stores'

class RequestProcessor {
  constructor() {
    this.requestCount = 0 // For loading 使用的，用于请求计数，并且判断所有请求是否已经完成的
    this.timeOutId = null // 请求超时 timer，超时后，就会自动隐藏 loading
  }

  isNetworkError(errorMessage) {
    return errorMessage === 'Network Error'
  }

  showLoading() {
    // 请求数量，当多个请求同时执行时，requestCount +1，某个请求完成后 requestCount -1，requestCount 等于 0 时 loading 隐藏
    this.requestCount++

    let isFirstRequest = this.requestCount === 1
    if (isFirstRequest) {
      store.dispatch('app/toggleLoading', { loading: true })
    }

    if (this.timeOutId !== null) clearTimeout(this.timeOutId)
    // 十秒后如果 loading 没有隐藏，则强制隐藏 loading，并且 requestCount 重新初始化为0
    this.timeOutId = setTimeout(() => {
      if (this.requestCount !== 0) {
        this.requestCount = 0
        store.dispatch('app/toggleLoading', { loading: false })
      }
    }, 10000)
  }

  hideLoading() {
    this.requestCount--
    if (this.requestCount === 0) {
      store.dispatch('app/toggleLoading', { loading: false })
    }
  }

  /**
   * 处理错误响应，主要是：错误信息提示
   *
   * @param {object} error 错误http响应
   */
  processErrorResponse(error) {
    // Do something with response error
    if (error.response) {
      // let content = ''
      let code = error.response.status

      if (code === 400) {
        // 错误。error_code, error_msg
        // 这里不作处理，一般在 axios.catch(..){...} 中处理
      } else if (code === 401) {
        // 认证失败。Token 无效
        // router.push('/auth/sign_in')
      } else if (code === 403) {
        // 授权拒绝。没有访问当前API的权限
        // toast.error('没有权限访问 GET /backend/orders')
      } else if (code === 422) {
        // 参数错误。一般只存在开发环境
        // toast.error('参数错误')
      } else {
        // toast.error('未知错误，请联系管理员')
      }
    } else {
      // 网络信号不健康通知
      if (this.isNetworkError(error.message)) {
        // toast.error('无法访问到服务器，请检查网络是否连接正常')
        store.dispatch('app/toggleNetwork', { health: false })
      } else {
        // toast.error('未知错误，请联系管理员')
      }
    }
  }

  /**
   * 获取 API 信息，如 "get /admins"
   *
   * @param {object} httpConfig HTTP配置
   * @returns {string} API
   */
  getApiStr(httpConfig) {
    return httpConfig.method + ' ' + httpConfig.url.replace(httpConfig.baseURL, '')
  }
}

export default RequestProcessor
